import React from 'react';
import {
  ADDITIONAL_CHARGES_TITLE,
  ADDITIONAL_CHARGES_LINE,
  ADDITIONAL_CHARGES_NOTE,
  shouldShowAdditionalChargesNotice,
} from '../lib/additionalChargesNotice';
import '../styles/AdditionalChargesNotice.css';

/**
 * Global Additional Charges notice for fare/results.
 * Shared by homepage and all hub/route/corridor booking cards via BookingForm.
 * Trip-neutral: One Way Drop and Round Trip. Does not alter fare calculation.
 */
const AdditionalChargesNotice = ({ tripType, className = '' }) => {
  if (!shouldShowAdditionalChargesNotice(tripType)) return null;

  return (
    <aside
      className={`extra-charges${className ? ` ${className}` : ''}`}
      role="note"
      aria-label="Additional charges"
    >
      <h3 className="extra-charges__title">{ADDITIONAL_CHARGES_TITLE}</h3>
      <p className="extra-charges__line">{ADDITIONAL_CHARGES_LINE}</p>
      <p className="extra-charges__note">{ADDITIONAL_CHARGES_NOTE}</p>
    </aside>
  );
};

export default AdditionalChargesNotice;
